import React, { useEffect } from "react";
import { Typography, Box, Divider, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { useScreenSize } from "../_context/ScreenSizeProvider";
import {
  variantBody,
  variantHeading,
  variantMap,
} from "../../_utils/constraints";
import useSmoothResponsiveFontSize from "../../_hook/useSmoothResponsiveFontSize";

const MotionBox = motion(Box);

const ShadowedDivider = ({
  mySpacing = 3,
  height = "4px",
  dividerHeight = "2px",
  leftRightInset = "5px",
  topShadow = "0px 4px 5px rgba(0, 0, 0, 0.2)",
  bottomShadow = "0px -4px 5px rgba(0, 0, 0, 0.2)",
  animationDuration = 0.5,
}) => (
  <MotionBox
    sx={{
      my: (theme) => theme.spacing(mySpacing),
      height,
      position: "relative",
      px: 2,
    }}
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: animationDuration }}
  >
    <Divider
      sx={{
        height: dividerHeight,
        backgroundColor: "gray",
        position: "absolute",
        top: 0,
        left: leftRightInset,
        right: leftRightInset,
      }}
    />
    {[topShadow, bottomShadow].map((shadow, index) => (
      <MotionBox
        key={index}
        sx={{
          position: "absolute",
          [index === 0 ? "top" : "bottom"]: index === 0 ? "-1px" : "1px",
          left: leftRightInset,
          right: leftRightInset,
          height: "100%",
          boxShadow: shadow,
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: animationDuration }}
      />
    ))}
  </MotionBox>
);

const HeaderSection = ({ title = "Page Title", description }) => {
  const theme = useTheme();

  const customfontsize = useSmoothResponsiveFontSize();

  return (
    <Box sx={{ textAlign: "center", width: "100%" }}>
      <Typography
        variant={"h1"}
        color="textPrimary"
        sx={{
          textTransform: "uppercase",
          my: theme.spacing(5),
          fontSize: `${2 * customfontsize}px`,
        }}
      >
        {title}
      </Typography>

      <ShadowedDivider />

      {description && (
        <Typography
          variant={"body2"}
          color="textPrimary"
          sx={{
            mb: theme.spacing(3),
            textAlign: {
              md: "start",
              xs: "start",
              lg: "center",
              fontSize: `${customfontsize}px`,
            },
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default HeaderSection;
